import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const LoadingState: React.FC = () => (
  <LoadingStateWrapper className={styles.banner}>
    <Skeleton variant="rectangular" height="160px" animation="pulse" />
    <Skeleton
      className={styles.pagination}
      variant="rectangular"
      height="6px"
      width="42px"
      animation="pulse"
    />
  </LoadingStateWrapper>
);

export default LoadingState;
